// extracted by mini-css-extract-plugin
export default {"info":"infoBox_info__aqDPE","pulse":"infoBox_pulse__Mcp6n"};